import * as React from 'react'
import './CustomMetricRow.css'
import CustomMetricSelectors, { Props as SelectorsProps } from './CustomMetricSelectors/CustomMetricSelectors'
import { Dashboard } from '@mulesoft/monitoring-center-components/lib/components/Dashboard/Dashboard'
import { DashboardLoadingState } from '@mulesoft/monitoring-center-components/lib/components/Dashboard/DashboardLoadingState'
import { buildCustomMetricDashboard, styles } from './util/GraphService'
import { CustomMetric } from '../model'
import { DashboardError } from '@mulesoft/monitoring-center-components'
import { Environment, Profile } from '../../../../remote-api/CoreServicesRemoteApi'

export type ExternalProps = {
  orgId: string
  envId?: string
  appId?: string
  rsType?: string
  targetId?: string
  from: string
  to: string
  metric: CustomMetric
  onDashboardStateChange: (loading: DashboardLoadingState, uri: string, iframe?: HTMLIFrameElement) => void
  onDashboardError: (error: DashboardError) => void
}

export type ValueProps = ExternalProps & {
  isAggregationSelectorLoading: boolean
  aggregations?: string[]
  selectedAggregation?: string
  isMeasureSelectorLoading: boolean
  measures?: string[]
  selectedMeasure?: string
  isDimensionSelectorLoading: boolean
  dimensions?: string[]
  selectedDimension?: string
  profile?: Profile
  selectedEnvironment?: Environment
}

export interface EventProps {
  fetchAggregations: (metricName: string, appId?: string) => void
  fetchMeasures: (metricName: string, isProductionEnv?: boolean) => void
  fetchDimensions: (metricName: string, isProductionEnv?: boolean) => void
  aggregationSelected: (metricName: string, appId?: string) => (aggregation: string) => void
  measureSelected: (metricName: string, appId?: string) => (measure: string) => void
  dimensionSelected: (metricName: string, appId?: string) => (dimension: string) => void
}

export type Props = ValueProps & EventProps

export class CustomMetricRow extends React.Component<Props> {

  constructor(props: Props) {
    super(props);

    this.getSelectorsProps = this.getSelectorsProps.bind(this)
  }

  componentDidMount() {
    const isProductionEnv = this.props.selectedEnvironment && this.props.selectedEnvironment.isProduction
    
    this.props.fetchAggregations(this.props.metric.name, this.props.appId)
    this.props.fetchMeasures(this.props.metric.name, isProductionEnv)
    this.props.fetchDimensions(this.props.metric.name, isProductionEnv)
  }

  getSelectorsProps(): SelectorsProps {
    return {
      isAggregationSelectorLoading: this.props.isAggregationSelectorLoading,
      aggregations: this.props.aggregations,
      selectedAggregation: this.props.selectedAggregation,
      isMeasureSelectorLoading: this.props.isMeasureSelectorLoading,
      measures: this.props.measures,
      selectedMeasure: this.props.selectedMeasure,
      isDimensionSelectorLoading: this.props.isDimensionSelectorLoading,
      dimensions: this.props.dimensions,
      selectedDimension: this.props.selectedDimension,
      aggregationSelected: this.props.aggregationSelected(this.props.metric.name, this.props.appId),
      measureSelected: this.props.measureSelected(this.props.metric.name, this.props.appId),
      dimensionSelected: this.props.dimensionSelected(this.props.metric.name, this.props.appId)
    }
  }

  public render() {
    const {orgId, envId, appId, rsType, targetId, metric, from, to, profile, selectedEnvironment} = this.props
    const isProductionEnv = selectedEnvironment && selectedEnvironment.isProduction
    const selectorsProps = this.getSelectorsProps()

    return (
      <div className="custom-metric-row-container">
        <Dashboard
          key={`${selectorsProps.selectedAggregation}-${selectorsProps.selectedMeasure}-${selectorsProps.selectedDimension}-${from}-${to}`}
          dashboardData={buildCustomMetricDashboard(metric, orgId, envId, appId, rsType, targetId, isProductionEnv)}
          id={'anypoint-platform-dashboard-id'}
          sameOrigin={true}
          onDashboardStateChange={this.props.onDashboardStateChange}
          onDashboardError={this.props.onDashboardError}
          from={from}
          to={to}
          styles={styles()}
          profile={profile}
        />
        <CustomMetricSelectors {...selectorsProps}  />
      </div>
    );
  }

}
